export default __webpack_public_path__ + "static/media/site-map.d8251b89.jpg";